export default ({ skip = 3, modifier = 'threshold.0.5', opacity = 'opacity-100' } = {}) => ({

    skip: skip,
    atBeginning: false,
    atEnd: false,

    next() {
        this.to((current, offset) => current + (offset * this.skip));
    },

    previous() {
        this.to((current, offset) => current - (offset * this.skip));
    },

    to(strategy) {
        let slider = this.$refs.slider;
        let current = slider.scrollLeft;
        let offset = slider.children.length > 1 ? slider.children[1].getBoundingClientRect().width : slider.children[0].getBoundingClientRect().width;
        slider.scrollTo({
            left: strategy(current, offset),
            behavior: 'smooth',
        });
    },

    carousel: {
        ['x-on:keydown.right']() {
            return this.next();
        },
        ['x-on:keydown.left']() {
            return this.previous();
        },
    },

    previousButton: {
        ['x-on:click']() {
            this.previous();
        },
        ['x-bind:aria-disabled']() {
            return this.atBeginning;
        },
        ['x-bind:tabindex']() {
            return this.atBeginning ? -1 : 0;
        },
        ['x-bind:class']() {
            return this.atBeginning ? 'opacity-50 cursor-not-allowed' : '';
        },
    },

    nextButton: {
        ['x-on:click']() {
            this.next();
        },
        ['x-bind:aria-disabled']() {
            return this.atEnd;
        },
        ['x-bind:tabindex']() {
            return this.atEnd ? -1 : 0;
        },
        ['x-bind:class']() {
            return this.atEnd ? 'opacity-50 cursor-not-allowed' : '';
        },
    },

    slider: {
        ['x-ref']: 'slider',
    },

    focusableWhenVisible: {
        ['x-intersect:enter']() {
            this.$el.removeAttribute('tabindex');
        },
        ['x-intersect:leave']() {
            this.$el.setAttribute('tabindex', '-1');
        },
    },

    disableNextAndPreviousButtons: {
        [`x-intersect:enter.${modifier}`]() {
            let slideEls = this.$el.parentElement.children;

            this.$el.classList.remove(opacity);

            // If this is the first slide.
            if (slideEls[0] === this.$el) {
                this.atBeginning = true;
                // If this is the last slide.
            } else if (slideEls[slideEls.length - 1] === this.$el) {
                this.atEnd = true;
            }
        },
        [`x-intersect:leave.${modifier}`]() {
            let slideEls = this.$el.parentElement.children;

            this.$el.classList.add(opacity);

            // If this is the first slide.
            if (slideEls[0] === this.$el) {
                this.atBeginning = false;
                // If this is the last slide.
            } else if (slideEls[slideEls.length - 1] === this.$el) {
                this.atEnd = false;
            }
        },
    },
})
